import { TTHTKnowledgeBankOverviewSection } from "./components/Sections/KnowledgeBankOverview/TTHTKnowledgeBankOverviewSection";
import { TTHTLessonPlanOverviewSection } from "./components/Sections/LessonPlanOverview/TTHTLessonPlanOverviewSection";
import { TTHTSchoolProfileSection } from "./components/Sections/SchoolProfile/TTHTSchoolProfileSection";
import { TTHTUnitOverviewSection } from "./components/Sections/UnitOverview/TTHTUnitOverviewSection";
import { TTHTPlanetWatchSection } from "./components/Sections/PlanetWatch/TTHTPlanetWatchSection";
import { TTHTExploreSection } from "./components/Sections/Explore/TTHTExploreSection";
import { TTHTWelcomeSection } from "./components/Sections/Welcome/TTHTWelcomeSection";
import { TTHTContainer } from "./TeachersToolkitHowTo.styled";
import { TabMargin } from "../components/TabMargin";
import React from "react";

export const TeachersToolkitHowTo = () => {
  return (
    <TTHTContainer>
      <TabMargin />
      <TTHTWelcomeSection />
      <TTHTExploreSection />
      <TTHTUnitOverviewSection />
      <TTHTLessonPlanOverviewSection />
      <TTHTKnowledgeBankOverviewSection />
      <TTHTSchoolProfileSection />
      <TTHTPlanetWatchSection />
    </TTHTContainer>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/TeachersToolkitHowTo.js